import { z } from 'zod';
export const MonthArray = z.array(z.number().int().nullable()).length(12);
export const MonthArrayNoNull = z.array(z.number().int()).length(12);
